module.exports = __webpack_public_path__ + "static/media/order.9c259bdf.svg";